import type { TabViewProps } from "./tab-view.type";

import { Tabs, type TabsProps } from "antd";
import cn from "classnames";

import { TabViewNav } from "./tab-view-nav";
import { computeTabItems } from "./tab-view.helper";

import "./tab-view.style.less";

export const TabView = ({
  tabs,
  isNav,
  isFullHeight,
  isNested,
  activeKey,
  defaultActiveKey,
  onChange,
  size,
  type,
  tabPlacement,
  tabBarExtraContent,
  className,
  classNames,
  // Nav params
  tabKey,
  paramsToKeep,
  alwaysSyncSearchParams,
  shouldSync,
}: TabViewProps) => {
  const items = computeTabItems(tabs);

  const tabsProps: TabsProps = {
    items,
    activeKey,
    defaultActiveKey,
    onChange,
    size,
    type: type ?? (isNested ? "card" : undefined),
    tabPlacement: tabPlacement ?? (isNested ? "top" : undefined),
    tabBarExtraContent,
    className: cn("tab-view", className, {
      "-full-height": isFullHeight,
      "-nested": isNested,
    }),
    classNames: {
      ...classNames,
      header: cn("tab-view--header", classNames?.header),
      body: cn("tab-view--body", classNames?.body),
      content: cn("tab-view--content", classNames?.content),
      item: cn("tab-view--item", classNames?.item),
    },
  };

  if (isNav) {
    return (
      <TabViewNav
        {...tabsProps}
        tabKey={tabKey}
        paramsToKeep={paramsToKeep}
        alwaysSyncSearchParams={alwaysSyncSearchParams}
        shouldSync={shouldSync}
      />
    );
  }

  return <Tabs {...tabsProps} />;
};
